import React,{useEffect,useState} from "react"
import api from "../api/api"
import { toast } from "react-toastify";

function ShippingSettings(){

const [data,setData] = useState({
 freeShippingAmount:"",
 standardCharge:"",
 expressCharge:"",
 codCharge:"",
 deliveryDays:""
})

useEffect(()=>{
 loadShipping()
},[])

const loadShipping = async ()=>{
 try{
 const res = await api.get("/settings/shipping")
 if(res.data) setData(res.data)
 }catch(error){
 console.error("Shipping load error:",error)
 }
}

const handleChange=(e)=>{
 setData({...data,[e.target.name]:e.target.value})
}

const handleSubmit=async(e)=>{
 e.preventDefault()

 try{
 await api.put("/settings/shipping",data)
 toast.success("Shipping settings updated ✅");
 
 }catch(error){
 console.error("Update error:",error)
 }
}

return(

<div className="container mt-4">

<div className="card shadow-sm">

<div className="card-header " style={{backgroundColor : "#BFC9D1"}}>
<h5 style={{lineHeight : "1.5", color : "white"}}>Shipping Settings</h5>
</div>

<div className="card-body">

<form onSubmit={handleSubmit}>

<div className="row">

<div className="col-md-6">
<label>Free Shipping Above</label>
<input name="freeShippingAmount" value={data.freeShippingAmount||""} onChange={handleChange} className="form-control"/>
</div>

<div className="col-md-6">
<label>Standard Charge</label>
<input name="standardCharge" value={data.standardCharge||""} onChange={handleChange} className="form-control"/>
</div>

<div className="col-md-6 mt-3">
<label>Express Charge</label>
<input name="expressCharge" value={data.expressCharge||""} onChange={handleChange} className="form-control"/>
</div>

<div className="col-md-6 mt-3">
<label>COD Charge</label>
<input name="codCharge" value={data.codCharge||""} onChange={handleChange} className="form-control"/>
</div>

<div className="col-md-6 mt-3">
<label>Delivery Days</label>
<input name="deliveryDays" value={data.deliveryDays||""} onChange={handleChange} className="form-control"/>
</div>

</div>

<button className="btn btn-primary mt-4">
Save Settings
</button>

</form>

</div>

</div>

</div>

)

}

export default ShippingSettings